export const DEFAULT_CAMERA_STATE = {
    name: '',
    rtsp_url: '',
    stream_url: '',
    location: '',
    resolution_width: 800,
    resolution_height: 600,
    framerate: 15,
    rotation: 0,
    text_left: '%N',
    text_right: '%Y-%m-%d %H:%M:%S',
    storage_profile_id: null,
    storage_path: '',
    root_directory: '',
    movie_file_name: '%Y-%m-%d/%H-%M-%S',
    movie_passthrough: true,
    movie_quality: 75,
    recording_mode: 'Motion Triggered',
    max_movie_length: 120,
    preserve_movies: 'For One Week',
    auto_threshold_tuning: true,
    auto_noise_detection: true,
    light_switch_detection: 0,
    despeckle_filter: false,
    motion_gap: 10,
    threshold: 1500,
    captured_before: 30,
    captured_after: 30,
    min_motion_frames: 2,
    mask: false,
    show_frame_changes: true,
    create_debug_media: false,

    // Scheduling
    schedule_monday: true,
    schedule_monday_start: '00:00',
    schedule_monday_end: '23:59',
    schedule_tuesday: true,
    schedule_tuesday_start: '00:00',
    schedule_tuesday_end: '23:59',
    schedule_wednesday: true,
    schedule_wednesday_start: '00:00',
    schedule_wednesday_end: '23:59',
    schedule_thursday: true,
    schedule_thursday_start: '00:00',
    schedule_thursday_end: '23:59',
    schedule_friday: true,
    schedule_friday_start: '00:00',
    schedule_friday_end: '23:59',
    schedule_saturday: true,
    schedule_saturday_start: '00:00',
    schedule_saturday_end: '23:59',
    schedule_sunday: true,
    schedule_sunday_start: '00:00',
    schedule_sunday_end: '23:59',

    notify_start_email: false,
    notify_start_telegram: false,
    notify_start_webhook: false,
    notify_end_webhook: false,
    notify_webhook_url: '',
    notify_telegram_token: '',
    notify_telegram_chat_id: '',
    notify_email_address: '',
    notify_health_email: false,
    notify_health_telegram: false,
    notify_health_webhook: false,
    detect_motion_mode: 'Always',
    picture_file_name: '%Y-%m-%d/%H-%M-%S-%q',
    picture_quality: 75,
    picture_recording_mode: 'Manual',
    preserve_pictures: 'Forever',
    max_pictures_storage_gb: 0,
    enable_manual_snapshots: true,
    rtsp_transport: 'tcp',
    live_view_mode: 'auto',
    notify_attach_image_email: true,
    notify_attach_image_telegram: true,
    privacy_masks: null,
    motion_masks: null,
    
    // AI & Tracking
    ai_enabled: false,
    ai_object_types: ['person', 'vehicle'],
    ai_threshold: 0.5,
    ai_tracking_enabled: false,
    detect_engine: 'OpenCV'
};
